import React from 'react';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import styled from 'styled-components';
import {contentIcAddCircle24px} from '@ey/motif-react-wrapper/assets/icons';

const AddElementButton = (props) => {
	return (
		<StyledAddElementButton
			onClick={props.onClick}
			className={`add-element-button ${props.className ? props.className : ''}`}
		>
			<MotifIcon src={contentIcAddCircle24px} className={`${props.className ? 'existing-'+ props.className : 'motif-icon'}`} />
				<span className={`button-label ${props.className ? props.className : ''}`}>{props.label}</span>
		</StyledAddElementButton>
	);
};

export default AddElementButton;

const StyledAddElementButton = styled.section`
	margin: 0rem 3rem 1rem 0;
	display: inline-block;
	cursor: pointer;

	.button-label {
		color: ${(props) => props.theme.color[`blue600`]};
		font-size: 1.4rem;
		font-weight: normal;
		display: inline-block;
		margin-left: 0.5rem;
	}

	.disabled {
		color: ${(props) => props.theme.color[`grey300`]} !important;
		font-size: 1.4rem;
		font-weight: normal;
		display: inline-block;
		margin-left: 0.5rem;
		cursor: not-allowed;
	}

	.motif-icon {
		svg {
			fill: ${(props) => props.theme.color[`blue600`]};
		}
	}

	.existing-disabled {
		svg {
			cursor: not-allowed;
			fill: ${(props) => props.theme.color[`grey300`]} !important;
		}
	}
`;
